module.exports = __webpack_public_path__ + "static/media/rpx.0a3bf7e1.svg";